<template>
  <div style="height: 100%">
    <app-base-main parentTable no-padding class="application-content">
      <template #filter-group>
        <app-filter-group
          @reset="$gjReset"
          @query="$gjNoticeQuery"
          :isBr="false"
        >
          <gj-market-select
            v-model="params.marketIdList"
            multiple
            adMarket
            :clearable="true"
            width="150px"
            placeholder="站点"
            @change="handleMarket"
          ></gj-market-select>
          <gj-select
            v-model="params.objectType"
            width="150px"
            :options="objectSelect"
            placeholder="应用对象类型"
          ></gj-select>

          <gj-virtual-select-more
            v-model="params.campaignIdList"
            :list="activitySelect"
            placeholder="所有广告活动"
            @change="handleCampaign"
            width="200px"
            clearable 
            type="multi-check"
            :filterable="false"
          >
          </gj-virtual-select-more>

          <!-- <gj-select
            v-model="params.campaignIdList"
            :options="activitySelect"
            placeholder="所有广告活动"
            type="multi-check"
            @change="handleCampaign"
            width="160px"
          ></gj-select> -->

          <gj-select
            v-model="params.groupIdList"
            :options="groupOption"
            placeholder="所有广告组"
            type="multi-check"
            width="160px"
          ></gj-select>
          <gj-select
            v-model="params.adsStatus"
            width="120px"
            :options="activeSelect"
            placeholder="广告活跃状态"
          ></gj-select>
          <gj-select
            v-model="params.type"
            width="110px"
            :options="autoSelect"
            placeholder="自动化类型"
          ></gj-select>
          <!-- <gj-select
          v-model="params.templateState"
          width="110px"
          :options="templateSelect"
          placeholder="模板状态"
        ></gj-select> -->
          <gj-select-input
            v-model="keyword"
            :width="['120px', '150px']"
            :options="[
              { id: 'templateName', text: '模板名称' },
              { id: 'objectName', text: '应用对象' },
            ]"
          >
          </gj-select-input>
        </app-filter-group>
      </template>
      <template #operate-group>
        <gj-select
          v-model="tableStrategy"
          :disabled="noSelect"
          width="120px"
          :clearable="false"
          :options="strategySelect"
          @change="handleTable('tableStrategy')"
          placeholder="分时策略"
        ></gj-select>
        <gj-select
          v-model="tableRule"
          :disabled="noSelect"
          width="120px"
          :clearable="false"
          :options="ruleSelect"
          @change="handleTable('tableRule')"
          placeholder="自动规则"
        ></gj-select>
      </template>
      <template #tool-group>
        <!-- <gj-checkbox v-model="params.cbox" @input="$gjNoticeQuery">
        <span style="color: #666">仅展示分时策略数据</span>
      </gj-checkbox>
      <gj-checkbox
        v-model="params.cbox"
        style="margin-right: 16px"
        @input="$gjNoticeQuery"
      >
        <span style="color: #666">仅展示自动规则数据</span>
      </gj-checkbox> -->
        <gj-tool-group
          help
          style="margin: 0"
          :helpName="helpName"
        ></gj-tool-group>
      </template>
      <template #table>
        <gj-table
          ref="gjTable"
          adaptParent
          :index="false"
          selection
          :loading="loading"
          :data="tableData"
          :columns="tableColumns"
          :show-overflow="false"
          :pagination="pagination"
          :header-cell-class-name="headerCellClassName"
          :default-sort="{ prop: 'slot:campaignName', order: 'ascending' }"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery"
          class="guide-table-object"
        >
          <template #objectName="{ row }">
            <div>
              <div style="margin-bottom: 4px">{{ row.objectName }}</div>
              <el-tag
                size="mini"
                type="info"
                style="margin-right: 10px; color: #666666"
                v-if="row.objectType"
                >{{ objectAdsType[row.objectType] }}</el-tag
              >
              <el-tag size="mini" type="success" v-if="row.adsStatus">{{
                row.adsStatus | optionText(activeSelect)
              }}</el-tag>
              <gj-popover v-else trigger="hover">
                <template slot="reference">
                  <el-tag size="mini" type="danger"
                    >{{ row.adsStatus | optionText(activeSelect) }}
                    <i class="el-icon-arrow-down"></i>
                  </el-tag>
                </template>
                <div class="ad-status">
                  <span>广告活动</span>
                  <span
                    :style="{
                      color: row.campaignState === 0 ? '#333333' : '#F5222D',
                    }"
                    >{{ row.campaignState === 0 ? "启动中" : "暂停中" }}</span
                  >
                </div>
                <div class="ad-status">
                  <span>广告组</span>
                  <span
                    :style="{
                      color: row.groupState === 0 ? '#333333' : '#F5222D',
                    }"
                    >{{ row.groupState === 0 ? "启动中" : "暂停中" }}</span
                  >
                </div>
                <div class="ad-status" v-if="row.state !== null">
                  <span>投放</span>
                  <span
                    :style="{ color: row.state === 0 ? '#333333' : '#F5222D' }"
                    >{{ row.state === 0 ? "启动中" : "暂停中" }}</span
                  >
                </div>
              </gj-popover>
            </div>
          </template>
          <template #campaignName="{ row }">
            <div>{{ row.campaignName }}</div>
          </template>
          <template #strategyObject="{ row }">
            <div
              v-if="row.strategyObject"
              style="display: flex; align-items: center"
            >
              <gj-switch
                @input="handleStrategy($event ? 0 : 1, [row], null, false)"
                size="small"
                :value="row.strategyObject.state"
                :disabled="row.switchLoading"
                :active-text="row.strategyObject.state ? '开启' : '关闭'"
              >
              </gj-switch>

              <div class="gj-cell-display-switch" style="margin: 3px 0 0 8px">
                <gj-tooltip
                  content="编辑"
                  v-if="$permission('adsStrategyTemplate:update')"
                >
                  <i
                    class="el-icon-edit color999"
                    @click="addStrategy(row)"
                  ></i>
                </gj-tooltip>
                <gj-tooltip
                  content="移除"
                  v-if="$permission('adsStrategyObject:delete')"
                >
                  <i
                    class="iconfont iconshanchu size13 color999"
                    style="margin-left: 10px"
                    @click="handleStrategy(2, [row])"
                  ></i>
                </gj-tooltip>
              </div>
            </div>
            <div v-else>
              <span>未添加</span>
              <span
                class="add gj-cell-display-switch"
                @click="addStrategy(row)"
                v-if="$permission('adsStrategyTemplate:add')"
                >去添加</span
              >
            </div>
          </template>
          <template #autoRuleObjectList="{ index, row }">
            <div
              class="rule-content"
              v-for="(item, iIndex) in row.autoRuleObjectListFilter"
              :key="item.id"
            >
              <el-tag
                style="color: #666666; border: none"
                size="mini"
                type="info"
                >{{
                  item.templateType === "template" ? "模板" : "非模板"
                }}</el-tag
              >
              <div>
                <gj-tooltip style="margin-left: 8px" :text-line="1" :content="item.templateName">{{item.templateName }}</gj-tooltip>
              </div>
              <span
                style="margin-left: 12px; width: 100px"
                v-if="row.autoRuleObjectListFilter.length - 1 === iIndex"
              >
                <el-popover
                  @show="handlePop(index)"
                  placement="top-end"
                  trigger="click"
                  popper-class="ad-rule-pop"
                >
                  <template slot="reference">
                    <span v-if="row.autoRuleObjectList.length > 2"
                      >共<span class="rule-btn" @click="handleRule(row)">{{
                        row.autoRuleObjectList.length
                      }}</span
                      >个</span
                    >
                    <span v-else class="rule-btn">详情</span>
                  </template>
                  <autoRule
                    :row="row"
                    :index="index"
                    :ref="`autoRuleRef${index}`"
                    @update="ruleUpdate"
                  ></autoRule>
                </el-popover>
              </span>
            </div>
            <div
              v-if="
                !row.autoRuleObjectListFilter &&
                (row.objectType === 'group' || row.objectType === 'campaign')
              "
            >
              <span>未添加</span>
              <span class="add gj-cell-display-switch" @click="addTemplate(row)"
                >去添加</span
              >
            </div>
            <div
              v-if="
                !row.autoRuleObjectListFilter &&
                !(row.objectType === 'group' || row.objectType === 'campaign')
              "
            >
              -
            </div>
          </template>
          <template #op="{ row }">
            <gj-button type="text" @click="handleLog(row)">日志</gj-button>
          </template>
        </gj-table>
      </template>
    </app-base-main>
    <guide
      :guideData="guideData"
      ref="guideRef"
      @cutTab="$emit('cutTab')"
    ></guide>
  </div>
</template>

<script>
import {
  objectSelect,
  activeSelect,
  autoSelect,
  templateSelect,
  strategySelect,
  ruleSelect,
  tableColumns,
  objectAdsType,
  strategyMap,
  AdStrategyStatusEnum,
  AdStrategyEnum,
  objectType,
  guideData,
} from "./config";
import { queryMixin, selectionMixin } from "@/minxins";
import {
  autoObject,
  queryCampaigns,
  batchUpdateStrategyObject,
  batchRule,
  addAdsAdjustStrategy,
  queryGroups,
  getResumeCondition,
} from "@/api/ad";
import { isMeaningful } from "@/utils/common";
import autoRule from "./auto-rule.vue";
import { mapGetters } from "vuex";
import AppAdTimeAdjustStrategyOpModal from "@/views/modules/ad/strategy/time-adjust/modal/strategy-op/time-adjust-strategy-op-modal.vue";
import { getAuthMarkets, getAdMarkets } from "@/api/common";
import { getAllMap } from "@/api/dashboard";
import _ from "lodash";
import AppAdLogModal from "@/views/modules/ad/common/modal/log/ad-log-new-modal";
import ToolTipBox from "@/views/modules/ad/strategy/time-adjust/modal/tool-tip-box/tool-tip-box";
import guide from "../guide.vue";
// 初始化查询参数
const initParams = () => {
  return {
    adsStatus: null, //  是否活跃
    adType: null, // 广告类型
    campaignIdList: [], // 广告活动id集合
    countryList: [], // 国家编码集合
    groupIdList: [], // 广告组id集合
    marketIdList: [], // 站点id集合
    objectName: null, // 应用对象名称
    objectType: null, // 应用类型
    templateName: null, // 模板名称
    templateState: null, // 模板状态
    type: null, // 自动化类型
  };
};
export default {
  name: "ad-application",
  components: { autoRule, guide },
  inject: ["removeTab", "getNavTabs"],
  mixins: [queryMixin, selectionMixin],
  data() {
    return {
      guideData,
      objectSelect, //应用对象下拉框
      activitySelect: [], // 广告活动
      groupOption: [], // 广告组
      activeSelect, // 广告活跃状态
      autoSelect, // 自动化类型
      templateSelect, // 模板状态
      strategySelect, // 分时策略
      ruleSelect, // 自动规则
      params: initParams(),
      tableStrategy: "", // 操作表格
      tableRule: "", // 操作表格
      tableData: [],
      tableColumns,
      objectAdsType,
      keyword: { key: "templateName", value: "" },
      firstQuery: true,
      guide: true,
      helpName: "timeadjuststrategy",
    };
  },
  computed: {
    ...mapGetters({ adMarkets: "adMarkets" }),
  },
  created() {
    // 排序默认查询
    this.sort = { prop: "campaignName", order: "ascending" };
  },
  activated() {
    this.routeMessage();
  },
  mounted() {
    this.routeMessage();
  },
  methods: {
    // 点击 重置, 初始化钩子
    $gjQueryInitParams() {
      console.log("重置");
      Object.assign(this.params, initParams());
      this.keyword = { key: "templateName", value: "" };
      // 重置广告组
      this.groupOption = [];
    },
    // 点击 查询, 查询钩子
    async $gjQuery() {
      if (this.firstQuery) {
        let aMarket = [];
        if (this.adMarkets && this.adMarkets.length > 0) {
          aMarket = this.adMarkets;
        } else {
          aMarket = await getAdMarkets();
        }
        // 默认第一个站点
        aMarket.length > 0 &&
          this.params.marketIdList.length === 0 &&
          this.params.marketIdList.push(aMarket[0].id);
        // 查询广告活动
        this.handleMarket();
        this.firstQuery = false;
      }
      this.loading = true;
      const params = {
        model: {
          ...this.params,
          [this.keyword.key]: this.keyword.value,
        },
        ...this.queryPagination,
        ...this.querySort,
      };
      autoObject(params)
        .then(({ data }) => {
          if (isMeaningful(data)) {
            data.records.forEach((item) => {
              if (item.strategyObject) {
                item.strategyObject.state = !item.strategyObject.state;
              }
              item.autoRuleObjectListFilter = item.autoRuleObjectList?.filter(
                (el, index) => index < 3
              );
              item.marketName = this.adMarkets.filter(
                (el) => el.id === item.marketId
              )[0];
              item.marketName = `${item.marketName?.text}:${item.marketName?.countryCode}`;
            });
            this.tableData = data.records;
            console.log(this.tableData);
            this.pagination = this.getPagination(data);
          } else {
            this.tableData = [];
          }
        })
        .finally(() => {
          this.loading = false;
          if (this.guide) {
            getAllMap().then((res) => {
              if (!res.adAutoRule) {
                // this.$refs.guideRef.start();
              }
            });
            this.guide = false;
          }
        });
    },
    handleLog(row) {
      // console.log(objectType[row.objectType]);
      this.$gjCreate(AppAdLogModal, {
        props: {
          objectName: row.objectName,
          marketId: row.marketId,
          adType: "SP",
          objectType: row.objectType,
          name: row.campaignName,
          radioActiveProp: 2,
        },
      });
    },
    //
    handleRule(row) {
      console.log(row);
    },
    // 查询自动规则详情
    handlePop(index) {
      this.$refs[`autoRuleRef${index}`][0].query();
    },

    // 操作分时策略
    handleStrategy: _.debounce(function (e, rowArr, callback, affirm = true) {
      const strMap = ["开启", "停用", "移除"];
      let modal = null;
      const _this = this;

      if (affirm) {
        modal = _this.$gjCreate("gj-info-modal", {
          props: {
            title: "操作确认",
            content: `确认${strMap[Number(e)]}分时策略，是否继续？`,
          },
          on: {
            cancel: () => {
              modal.$gjDestroy();
              callback && callback();
            },
            confirm: () => {
              queryFront();
            },
          },
        });
      } else {
        queryFront();
      }

      // 查询是否需要
      async function queryFront() {
        // 查询分时是否需要还原
        let frontData = [];
        // 当操作为删除2 或 暂停1 时需要查询是否还原
        if (e !== 0) {
          frontData = await getResumeCondition(
            rowArr.map((item) => {
              return {
                objectPid: item.strategyObject.id,
                operatingType: 1, // 修改策略
                status: e,
              };
            })
          );
        }
        // 判断检测到有需要还原的数据
        if (frontData && frontData.length) {
          const modal2 = _this.$gjCreate(ToolTipBox, {
            props: {
              msg: "分时调价策略正在生效中，请确认是否需要将预算和竞价恢复到基础预算和竞价",
              data: frontData,
            },
            on: {
              update: (resume, resumeTaskId) => {
                if (resume !== -1) {
                  // resume为true表示需要还原
                  resume ? updateData(resume, resumeTaskId) : updateData();
                } else {
                  // 等于 -1 表示取消
                  modal2.$gjDestroy();
                  modal && modal.$gjDestroy();
                  callback && callback();
                }
              },
            },
          });
        } else {
          updateData();
        }
      }

      // 改变分时策略状态
      async function updateData(resume, resumeTaskId) {
        const res = await batchUpdateStrategyObject(
          rowArr.map((item) => {
            return {
              marketId: item.marketId,
              objectPid: item.strategyObject.id,
              objectStatus: e,
              resume,
              resumeTaskId,
            };
          })
        );
        res.code === 0
          ? _this.$message.success(res.msg)
          : _this.$message.error(res.msg);
        modal && modal.$gjDestroy();
        _this.$gjQuery();
        callback && callback();
      }
    }, 200),

    handleTable(key) {
      // 批量操作分时策略
      if (key === "tableStrategy" && this["tableStrategy"] !== "") {
        this.handleStrategy(
          this["tableStrategy"],
          this.selectedRows.filter((item) => item.strategyObject),
          () => {
            this.tableStrategy = "";
          }
        );
      }

      // 批量操作自动化规则
      if (key === "tableRule") {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: "操作确认",
            content: `确认操作自动规则，是否继续？`,
          },
          on: {
            cancel: () => {
              modal.$gjDestroy();
            },
            confirm: () => {
              callback();
            },
          },
        });
        const callback = () => {
          const params = [];
          this.selectedRows.forEach((item) => {
            if (item.autoRuleObjectList) {
              item.autoRuleObjectList.forEach((el) => {
                params.push({
                  marketId: item.marketId,
                  id: el.id,
                  state: this["tableRule"],
                });
              });
            }
          });
          batchRule(params)
            .then((res) => {
              if (res.code === 0) {
                this.$message.success(res.msg);
                this.$gjQuery();
              } else {
                this.$message.error(res.msg);
              }
            })
            .finally(() => {
              this.tableRule = "";
              modal.$gjDestroy();
            });
        };
      }
    },

    // 添加分时策略
    addStrategy(row) {
      // 兼容状态
      const objectType = {
        campaign: 0,
        group: 1,
      };
      row.strategyStatus = row.strategyObject ? row.strategyObject.state : 2;
      row.originalBudget = row.originPrice;
      row.originalBid = row.originPrice;

      const modal = this.$gjCreate(AppAdTimeAdjustStrategyOpModal, {
        props: {
          title: `<span>分时策略</span><span class="modal-secondary-title">(${row.campaignName})</span>`,
          opType: 4,
          item: row,
          objectId: row.strategyObject?.id,
          strategyType: strategyMap[row.objectType], // 1：广告组、关键词、商品投放、投放组， 2：广告位， 3：广告活动
        },
        on: {
          useStrategy: ({
            params,
            status,
            templateId,
            callback,
            resumeDTO,
          }) => {
            modal.confirmLoading = true;
            let useParams;
            Promise.resolve(row.strategyStatus)
              .then((strategyStatus) => {
                if (strategyStatus === AdStrategyStatusEnum.NO_ADD) {
                  // 新增分时策略
                  useParams = {
                    resumeDTO,
                    id: row.strategyObject?.id,
                    adsStrategyTemplate: params,
                    marketId: row.marketId,
                    bid: row.dailyBudget,
                    status,
                    templateId,
                    campaignId: row.campaignId,
                    campaignName: row.campaignName,
                    objectId: row.objectId,
                    objectName: row.objectName,
                    objectType: objectType[row.objectType],
                  };
                  return addAdsAdjustStrategy(useParams);
                } else {
                  // 修改分时
                  useParams = [
                    {
                      ...params,
                      marketId: row.marketId,
                      objectPid: row.strategyObject?.id,
                      objectStatus: status,
                      templatePId: templateId,
                    },
                  ];
                  return batchUpdateStrategyObject(useParams);
                }
              })
              .then((res) => {
                if (callback) {
                  callback(res);
                }
              })
              .complete(() => (modal.confirmLoading = false));
          },
          updated: () => {
            this.$gjMessage.success("操作成功");
            this.$gjQuery();
            modal.$gjDestroy();
          },
        },
      });
    },
    // 规则pop更新列表数据
    ruleUpdate(arr, index) {
      this.$gjQuery();
    },
    // 路由跳转前处理
    handleRouter(callback, name) {
      const tabs = this.getNavTabs();
      if (tabs.some((item) => item.name === name)) {
        this.removeTab(name);
        callback();
      } else {
        callback();
      }
    },
    // 添加模板
    addTemplate(row) {
      const extra = [
        {
          marketId: row.marketId,
          adsType: row.adType,
          campaignId: row.campaignId,
          applyObjectId: row.objectId,
          applyObjectName: row.objectName,
          applyObjectAdsType: row.objectType,
        },
      ];
      this.handleRouter(() => {
        this.$router.push({
          path: `/ad/add-rule-template`,
          query: {
            type: "add",
            belong: "rule",
            sourceRoute: this.$route.path,
            extra: JSON.stringify(extra),
          },
        });
      }, "新增自动模板规则");
    },
    handleMarket() {
      console.log(this.params.marketIdList);
      if (this.params.marketIdList.length === 0) {
        this.params.campaignIdList = [];
        this.activitySelect = [];
      }
      queryCampaigns({
        // groupTargetingTypes: [0],
        marketIds: this.params.marketIdList,
        states: [0, 1],
        // targetingType: 0,
      }).then((res) => {
        res.forEach((item) => {
          item.id = item.campaignId;
          item.text = item.campaignName;
        });
        this.activitySelect = this.repetition(res);
        // 若广告活动有值
        if (this.params.campaignIdList.length > 0) {
          // this.handleCampaign(10);
          if (this.params.campaignIdList.length === 0) {
            this.params.groupIdList = [];
            this.groupOption = [];
          }
          this.queryGroupsfn();
        }
      });
    },
    // 查询广告组
    handleCampaign() {
      if (this.params.campaignIdList.length === 0) {
        this.params.groupIdList = [];
        this.groupOption = [];
      }
      this.campaignDebounce();
    },
    campaignDebounce: _.debounce(function () {
      this.queryGroupsfn();
    }, 500),

    queryGroupsfn() {
      if (this.params.campaignIdList.length > 0) {
        const params = {
          campaignIds: this.params.campaignIdList,
          // groupTargetingTypes: [0],
          marketIds: this.params.marketIdList,
          states: [0, 1],
          // targetingType: 0,
        };
        queryGroups(params).then((res) => {
          res.forEach((item) => {
            item.id = item.groupId;
            item.text = item.groupName;
          });
          this.groupOption = this.repetition(res);
        });
      }
    },

    //数组去重
    repetition(arr) {
      let map = new Map();
      for (let item of arr) {
        map.set(item.id, item);
      }
      return [...map.values()];
    },

    headerCellClassName({ column }) {
      console.log();
      if (column.field === "slot:strategyObject") {
        return "guide-col-strategy";
      }
      if (column.field === "slot:autoRuleObjectList") {
        return "guide-col-rule";
      }
      return null;
    },

    // 从消息中心跳转过来
    routeMessage() {
      if (this.$route.query.type === "message") {
        this.$router.push("/ad/ad-automate");
        setTimeout(() => {
          this.$gjCreate(AppAdLogModal, {
            props: {
              adType: "SP",
              radioActiveProp: 2,
            },
          });
        }, 100);
      }
      if (this.$route.query.extra) {
        const data = this.$route.query;
        data.extra = JSON.parse(data.extra);
        this.params.marketIdList = [data.extra.marketId];
        // 对象类型
        this.params.objectType = data.extra.objectType;
        // 应用对象
        this.keyword = { key: "objectName", value: data.extra.applyObjectName };
        this.params.campaignIdList = [data.extra.campaignId];
        this.params.groupIdList = data.extra.groupId
          ? [data.extra.groupId]
          : [];
      }
    },
  },
};
</script>

<style lang="scss">
.ad-rule-pop {
  padding: 0 !important;
}
</style>
<style scoped lang="scss">
.application-content {
  /deep/ .operate-group.is-align-middle {
    margin: 0;
  }
}

.rule-content{
  display: flex;
}
.rule-content + .rule-content {
  margin-top: 4px;
}

.ad-status {
  color: #333333;
  display: flex;
  justify-content: space-between;
}
.ad-status + .ad-status {
  margin-top: 8px;
}
.rule-btn {
  color: #1f6eef;
  cursor: pointer;
}
.add {
  display: none;
  color: #1f6eef;
  cursor: pointer;
  margin-left: 8px;
}
</style>
